import userService from "@/endpoints/userService";
import ShowToaster from "@/toaster";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateAiModelColor = createAsyncThunk<
  { modelId: number; color: string } | null,
  { modelId: number; color: string },
  { rejectValue: string }
>(
  "aiModels/updateColor",
  async ({ modelId, color }, thunkAPI) => {
    try {
      const response: string = (await userService.models.updateModelPreferences({
        payload: [{ entityId: modelId, color }],
      })) as any;
      return response ? { modelId, color } : null;
    } catch (err: any) {
      ShowToaster.error("Failed to update model color.");
      return thunkAPI.rejectWithValue(
        "Failed to update model color. " + err.message
      );
    }
  }
);
